import { useEffect, useState } from "react";
import Select from "react-select";

function RewardEarnTypeSelect(props) {
  const customOption = props?.list?.map((item) => ({
    ...item,
    label: `${item.Name}`,
  }));

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40, // Matches h-10 (40px)
      minHeight: 40,
      backgroundColor: "#fff",
      width: 160, // Matches w-40 (160px)
      border: "1px solid #d1d5db", // Matches border-gray-300
      borderRadius: "0.375rem", // Matches rounded-md
      padding: "0 12px",
      fontSize: "0.875rem", // Matches text-sm
      "&:focus-within": {
        ringWidth: "2px",
        ringColor: "#3b82f6", // Matches focus:ring-blue-500
        borderColor: "#3b82f6", // Matches focus:border-blue-500
      },
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    valueContainer: (styles) => ({
      ...styles,
      height: 36, // Adjusted to fit within control height
      padding: "0",
    }),
    option: (styles) => ({
      ...styles,
      backgroundColor: "#fff",
      color: "black",
      fontSize: "0.875rem", // Matches text-sm
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleChange = (value) => {
    props.onTypeSelect(value);
  };

  return (
    <Select
      placeholder="Select type"
      key={props.defaultVal}
      styles={customStyles}
      onChange={handleChange}
      defaultValue={props?.defaultVal}
      options={customOption}
      className={props.className}
    />
  );
}

export default RewardEarnTypeSelect;